import type { ReactAdminPageId } from '@/lib/react-admin-route-map';

/** Admin pages that mount DealerTreeProvider and fetch /api/admin/dealers-tree. */
export const DEALER_TREE_PAGE_IDS: ReadonlySet<ReactAdminPageId> = new Set([
  'reports',
  'sites',
  'operator-notices',
  'contacts',
  'wizard',
  'sops',
  'stats',
  'templates',
  'report-delivery',
  'delivered-reports',
  'tools',
]);

export function pageUsesDealerTree(pageId: ReactAdminPageId): boolean {
  return DEALER_TREE_PAGE_IDS.has(pageId);
}
